// Vendored from theme-system/packages/style-applicator/src/constants.ts (PRNT-4898).
import type { UserPreferences } from '../styleApplicator.types';

export const DEFAULT_USER_PREFERENCES: UserPreferences = {
  backgroundTranslucency: {
    isEnabled: false,
  },
  customBackgroundColor: {
    isEnabled: false,
    backgroundColor: [255, 255, 255, 1],
    textColor: [51, 51, 51, 1],
  },
};
